import { STATUSES } from "@/lib/engagements";

const ACCENT = {
  Completed: "bg-emerald-600",
  "In Progress": "bg-blue-600",
  Finalise: "bg-purple-600",
  "Long overdue": "bg-red-600",
  "Haven't start": "bg-zinc-400",
};

export const MetricBar = ({ stats, active, onSelect }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 border border-border divide-x divide-y md:divide-y-0 divide-border">
    {STATUSES.map((s) => {
      const isActive = active === s;
      return (
        <button
          key={s}
          data-testid={`metric-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          onClick={() => onSelect(isActive ? "" : s)}
          className={`text-left p-4 transition-colors ${isActive ? "bg-zinc-900 text-white" : "bg-white hover:bg-zinc-50"}`}
        >
          <div className="flex items-center gap-2">
            <span className={`h-2 w-2 rounded-full ${ACCENT[s]}`} />
            <span className={`text-xs uppercase tracking-widest ${isActive ? "text-zinc-300" : "text-zinc-500"}`}>
              {s}
            </span>
          </div>
          <div className="mt-3 text-4xl font-display font-extrabold tabular">
            {stats?.counts?.[s] ?? 0}
          </div>
        </button>
      );
    })}
  </div>
);
